import { useCallback } from 'react'

import { AccountType } from '@percent/domain/iam'
import type { AssigneeSearchResult } from '@percent/domain/iam'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { toAssigneeSearchResults } from './toAssigneeSearchResults'

const SEARCH_PAGE_SIZE = 10

/** Searches internal accounts and groups together; a failed half still answers the other. */
export function useSearchAssignees() {
  const { accountService, groupService } = useServices()

  return useCallback(
    async (query: string): Promise<AssigneeSearchResult[]> => {
      const [accounts, groups] = await Promise.allSettled([
        accountService.getAccounts({ search: query, pageSize: SEARCH_PAGE_SIZE, type: AccountType.internal }),
        groupService.searchGroups({ search: query, pageSize: SEARCH_PAGE_SIZE })
      ])

      return toAssigneeSearchResults(
        accounts.status === 'fulfilled' ? accounts.value.data?.data ?? [] : [],
        groups.status === 'fulfilled' ? groups.value.data?.data ?? [] : []
      )
    },
    [accountService, groupService]
  )
}
